
/* 是否手机号码或者固话*/
export function validatePhoneTwo(rule, value, callback) {
	const reg = /^((0\d{2,3}-\d{7,8})|(1[345789]\d{9}))$/;
	if (value == '' || value == undefined || value == null) {
		callback();
	} else {
		if ((!reg.test(value)) && value != '') {
			callback(new Error('请输入正确的电话号码或者固话号码'));
		} else {
			callback();
		}
	}
}
/* 是否固话*/
export function validateTelphone(rule, value,callback) {
	const reg =/0\d{2}-\d{7,8}/;
	if(value==''||value==undefined||value==null){
		callback();
	}else {
		if ((!reg.test(value)) && value != '') {
			callback(new Error('请输入正确的固话（格式：区号+号码,如010-1234567）'));
		} else {
			callback();
		}
	}
}
/* 是否手机号码*/
export function validatePhone(rule, value,callback) {
	const reg =/^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[0-9])\d{8}$/;
	if(value==''||value==undefined||value==null){
		callback(new Error('请输入手机号码'));
	}else {
		if ((!reg.test(value)) && value != '') {
			callback(new Error('请输入正确的手机号码'));
		} else {
			callback();
		}
	}
}

/* 是否youxiang*/
export function receiverEmil(rule, value,callback) {
	const reg =/^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
	if(value==''||value==undefined||value==null){
		callback(new Error('请输入邮箱号码'));
	}else {
		if ((!reg.test(value)) && value != '') {
			callback(new Error('请输入正确的邮箱号码'));
		} else {
			callback();
		}
	}
}
/* 是否身份证号码*/
export function validateIdNo(rule, value,callback) {
	const reg = /^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|[xX])$/;
	if(value==''||value==undefined||value==null){
		callback(new Error('身份证号码不能为空'));
	}else {
		if ((!reg.test(value)) && value != '') {
			callback(new Error('请输入正确的身份证号码'));
		} else {
			callback();
		}
	}
}
/* 是否社会信用代码*/
export function creditCode(rule, value,callback) {
	const num = /^([0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}|[1-9]\d{14})$/;
	if(value==''||value==undefined||value==null){
		return callback(new Error('社会信用代码不能为空'))
	}else if (!num.test(value)) {
		return callback(new Error('请输入正确社会信用代码'))
	} else {
		callback()
	}
}

/* 合法uri*/
export function validateURL(textval) {
	const urlregex = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/;
	return urlregex.test(textval);
}

/*验证内容是否姓名*/
export function isName(rule, value, callback) {
	const reg =/^([\u4E00-\u9FA5\uf900-\ufa2d·s]{2,20})$/;
	if(value==''||value==undefined||value==null){
		callback(new Error('请输入姓名'));
	} else {
		if (!reg.test(value)){
			callback(new Error('请输入正确格式姓名'));
		} else {
			callback();
		}
	}
}


/* 小写字母*/
export function validateLowerCase(str) {
	const reg = /^[a-z]+$/;
	return reg.test(str);
}
/*保留2为小数*/
export function validatetoFixedNew(str) {
	return str ;
}

/* 大写字母*/
export function validateUpperCase(str) {
	const reg = /^[A-Z]+$/;
	return reg.test(str);
}

/* 大小写字母*/
export function validatAlphabets(str) {
	const reg = /^[A-Za-z]+$/;
	return reg.test(str);
}